import React, { useState } from 'react';

const FAQSection = () => {
  // State to track which FAQ items are open
  const [openItems, setOpenItems] = useState([0]); // Default first item open

  const toggleItem = (index) => {
    setOpenItems(prevOpenItems => {
      if (prevOpenItems.includes(index)) {
        // If already open, close it
        return prevOpenItems.filter(item => item !== index);
      } else {
        // If closed, open it
        return [...prevOpenItems, index];
      }
    });
  };

  // FAQ data
  const faqItems = [
    {
      question: "What is an AeroFi RWA device?",
      answer: "AeroFi RWA (Real-World Asset) devices are physical WiFi hotspots that connect to the AeroFi network and serve dual purposes: providing global internet connectivity while simultaneously mining AFI tokens. Each device represents a tangible asset that bridges the physical and digital worlds, allowing you to earn passive income through our blockchain ecosystem."
    },
    {
      question: "How are token-denominated returns calculated?",
      answer: "Our rewards are calculated in AFI tokens, not USD value. This means a 100% Expected Annual Yield delivers 100% more AFI tokens over a year, but the USD value will vary with token price. Your device's package value is fixed at purchase (based on USDT cost ÷ AFI price), and your annual yield percentage (30-600%) is applied to this fixed AFI value. If protocol revenue is sufficient, you receive the full calculated Expected Annual Yield; if revenue is insufficient, yields are proportionally reduced."
    },
    {
      question: "What is the Temporal Reward Adjustment mechanism?",
      answer: "The Temporal Reward Adjustment mechanism ensures early adopters maintain a permanent advantage in the ecosystem. Early participants receive up to a 50% bonus through a formula that includes your entry position, staking commitment, and network saturation levels. This creates a fair system that rewards pioneers while remaining attractive to newcomers, as your position in the ecosystem is permanently recorded on-chain and reflected in your rewards."
    },
    {
      question: "What are the requirements to become a node operator?",
      answer: "To become a node operator, you need to meet specific staking requirements based on the node level: Standard Node (Level 1) requires 100,000 AFI with a 60-day lock period, Super Node (Level 2) requires 250,000 AFI with a 90-day lock period, Master Node (Level 3) requires 500,000 AFI with a 120-day lock period, and Apex Node (Level 4) requires 1,000,000 AFI with a 180-day lock period. Additionally, you'll need to demonstrate team management skills and commit to growing your community of device users."
    },
    {
      question: "How do node operators earn income?",
      answer: "Node operators earn income through multiple streams: a percentage of mining rewards from all devices in their team (10-18% depending on node level), commissions on device sales (7-15%), rewards when acting as a superior node (3-6%), and for Apex Nodes, a share of the registration fee reward pool. This creates a sustainable income model that grows with your team size and ecosystem contribution."
    },
    {
      question: "Can I upgrade my node level over time?",
      answer: "Yes, you can upgrade your node level as your team grows and you meet the requirements for higher tiers. Upgrading requires meeting the staking requirements for the new level, completing required training courses, achieving minimum team size requirements, and paying an upgrade fee (denominated in AFI). Each upgrade unlocks higher mining reward percentages, increased sales commission, and additional governance rights."
    },
    {
      question: "What happens if the network reaches maximum emission capacity?",
      answer: "Our system has a daily maximum emission cap (328,767 AFI in Year 1). If demand exceeds this capacity, rewards are distributed according to the Network Saturation Factor in our Temporal Reward Adjustment mechanism. Early adopters and higher-tier device owners receive priority, ensuring you maintain proportionally higher rewards even during periods of high network congestion. This sustainable approach prevents reward pool depletion while maintaining ecosystem fairness."
    },
    {
      question: "What are the uptime requirements?",
      answer: "Devices must maintain at least 85% uptime to receive full mining rewards. This requirement ensures network stability and quality of service. The system monitors connectivity status and calculates rewards accordingly. Quarterly system updates (approximately 2 hours) are not counted as offline time. Our user-friendly dashboard provides real-time uptime statistics and notifications if your device falls below the minimum threshold."
    },
    {
      question: "How are registration fees used?",
      answer: "Each device requires a one-time registration fee that is automatically deducted from mining rewards. Basic devices require 500 AFI, Pro devices 400 AFI, Elite devices 300 AFI, and Enterprise devices 200 AFI. 50% of this fee is permanently burned, reducing total token supply, while the other 50% goes to the registration fee reward pool distributed to top-performing nodes based on team metrics. This dual approach supports both token value and community building."
    },
    {
      question: "What voting rights do node operators have?",
      answer: "Node operators participate in governance based on their level. Standard Nodes have 1.0× voting weight and can vote on regular proposals. Super Nodes have 1.2× voting weight and can vote on regular and specialized proposals. Master Nodes have 1.5× voting weight, can vote on all proposals, and submit improvement proposals. Apex Nodes have 2.0× voting weight, can vote on all proposals, submit proposals, and vote on emergency actions."
    }
  ];

  return (
    <section className="faq-section" id="faq">
      <div className="container">
        <h2 className="section-title">Frequently Asked <span>Questions</span></h2>
        
        {faqItems.map((item, index) => (
          <div 
            key={index} 
            className={`faq-item ${openItems.includes(index) ? 'active' : ''}`}
          >
            <div className="faq-question" onClick={() => toggleItem(index)}>
              {item.question}
              <div className="faq-icon">+</div>
            </div>
            <div className="faq-answer">
              <p>{item.answer}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQSection;
